import { createContext } from 'react'

export interface FocusModeContextType {
  isFocusMode: boolean
  toggleFocusMode: () => void
  enterFocusMode: () => void
  exitFocusMode: () => void
}

export const FocusModeContext = createContext<FocusModeContextType | undefined>(undefined)
